/**
 * Normalize an object's snake_case keys to camelCase (P3-5 / MR-33).
 *
 * Extracted verbatim from app.vue's `fixKeyCase` method — `loadData` runs the
 * POST API's snake_case playlist/category response through it so the players
 * can read camelCase props. Pure (does not read `this`), so it works unchanged
 * both as `fixKeyCase(obj)` and as a bare `.map(fixKeyCase)` callback.
 *
 * Behavior is byte-identical to the original `key.replace(/_(.)/g, upper)`:
 * each `_x` becomes `X`; a leading `_x` capitalizes; a trailing `_` (no
 * following char) is left as-is; values are copied by reference (shallow).
 *
 * @param {Object} obj source object
 * @returns {Object} a new object with camelCased keys and the same values
 */
export const fixKeyCase = (obj) => {
  const ret = {};
  Object.keys(obj).forEach((key) => {
    const fixed = key.replace(/_(.)/g, (m, $1) => $1.toUpperCase());
    ret[fixed] = obj[key];
  });
  return ret;
};
